import axios from 'axios'
import API from '@/common/api'
import store from '..'
import router from '@/router'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getTicketList ({ state }) {
      const siteInfo = store.state.authentication
      const rid = siteInfo.rid
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-ticket',
          func: 'get-ticket-list',
          siteid: API.SITE_INFO.site,
          stayResvId: rid
        })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async getTicketDetail ({ state }, ticketId) {
      const siteInfo = store.state.authentication
      const rid = siteInfo.rid
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-ticket',
          func: 'get-ticket-detail',
          siteid: API.SITE_INFO.site,
          ticketId: ticketId
        })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
  },
  getters: {
  }
}